// Reveal animations removed — content now always renders at its final,
// fully-visible state. The scroll-triggered opacity/scale/slide reveals
// were breaking responsiveness (sections could get stuck hidden when the
// IntersectionObserver didn't fire at certain widths). Simple CSS
// transitions (e.g. card hover in the .scss files) handle the rest.

const visible = { x: 0, y: 0, scale: 1, opacity: 1 };

export const headerAnimation = { hidden: visible, show: visible };

export const imageAnimation = { hidden: visible, show: visible };

export const reveal = { hidden: { x: 0 }, show: { x: 0 } };

export const textAnimation = { hidden: { opacity: 1 }, show: { opacity: 1 } };

export const cardAnimation = { hidden: visible, show: visible };

export const fromUp = { hidden: visible, show: visible };

export const fromDown = { hidden: visible, show: visible };

export const topContainerAnimation = { hidden: { opacity: 1 }, show: { opacity: 1 } };

export const videoAnimation = { hidden: visible, show: visible };

export const reasonsAnimation = { hidden: visible, show: visible };

export const navbarAnimation = { hidden: { y: 0 }, show: { y: 0 } };
